import { useTranslation } from "react-i18next";
import {
  StageShell, ColumnHeader, Metric, SliderBlock, TOTAL_COINS, pctStr,
} from "./primitives";

export default function Stage3Investor({
  myCoins, setMyCoins, calc, fmtM,
}) {
  const { t } = useTranslation();

  return (
    <StageShell
      step={t("jc3_step")}
      role={t("jc3_role")}
      title={t("jc3_title")}
      desc={t("jc3_desc")}
      accentBg="bg-[#FFCC00]"
      accentText="text-black"
    >
      <div className="grid grid-cols-12 gap-6 mt-6">
        <div className="col-span-12 md:col-span-5">
          <ColumnHeader label={t("jc_stage_in")} accent="text-zinc-700" />
          <div className="space-y-5 border border-black/10 bg-white p-5">
            <SliderBlock
              id="coins"
              label={t("jc3_in_coins")}
              tip={t("tip_coins")}
              valueLabel={`${calc.coins.toLocaleString()} / ${TOTAL_COINS.toLocaleString()}`}
              value={myCoins}
              min={0}
              max={TOTAL_COINS}
              step={100}
              onChange={setMyCoins}
            />
            <div className="text-xs text-zinc-500 leading-relaxed">
              {t("calc_price_per_coin")}: <b className="tabular-nums">{fmtM(calc.pricePerCoin, 2)}</b> · {t("calc_return_per_coin")}: <b className="tabular-nums">{fmtM(calc.perCoinMonthly, 3)}</b>
            </div>
          </div>
        </div>

        <div className="col-span-12 md:col-span-7">
          <ColumnHeader label={t("jc_stage_out")} accent="text-[#002FA7]" />
          <div className="bg-black text-white p-6 border border-black/10 overflow-hidden">
            {/* Headline 4 metrics — vertical-friendly at md/lg so big numbers don't collide */}
            <div className="grid grid-cols-2 xl:grid-cols-4 gap-x-4 gap-y-5">
              <Metric k={t("jc3_out_pay")} v={fmtM(calc.invInvest, 0)} big tip={t("tip_pay")} />
              <Metric k={t("jc3_out_monthly")} v={fmtM(calc.invMonthly, 0)} big tip={t("tip_monthly")} />
              <Metric k={t("jc3_out_total")} v={fmtM(calc.invTotal, 0)} big tip={t("tip_total_in")} />
              <Metric k={t("jc3_out_roi")} v={pctStr(calc.invROI)} accent="text-[#FFCC00]" big tip={t("tip_roi")} />
            </div>
            {/* Secondary 3 metrics */}
            <div className="grid grid-cols-3 gap-x-4 gap-y-3 mt-6 pt-4 border-t border-white/10">
              <Metric k={t("jc3_out_net")} v={fmtM(calc.invNet, 0)} accent="text-[#FFCC00]" tip={t("tip_net_gain")} />
              <Metric k={t("jc3_out_apy")} v={pctStr(calc.invAPY)} tip={t("tip_apy_simple")} />
              <Metric k={t("jc3_out_be")} v={calc.invBE.toString()} tip={t("tip_be")} />
            </div>
            <div className="mt-5">
              <div className="h-2 bg-white/10">
                <div
                  className="h-full bg-[#FFCC00]"
                  style={{ width: `${Math.min(100, (calc.invBE / Math.max(calc.months, 1)) * 100)}%` }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </StageShell>
  );
}
